export default "__VITE_ASSET__RdhtJefq__"